<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="25" cy="25" r="23" stroke="black" stroke-width="4"/>
    <rect x="12" y="23" width="26" height="4" rx="1" fill="black"/>
    <rect x="27" y="12" width="26" height="4" rx="1" transform="rotate(90 27 12)" fill="black"/>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'WcIconPlusUnfilled',
  components: {
  },
  props: {
    color: String
  }
})
export default class extends Vue {
  @Prop({ default: '#000000' }) color!: string;
}
</script>

<style scoped>
</style>
